import _ from 'lodash';
import { SEGMENT_CONFIG } from 'v2/common/constants/index';
import { schemaShouldShowConfigTypes, schemaTypes } from '../outputSchema/config';
import { pipeInputSchemaTypes } from './config';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const configuration = {
  type: 'fixedRangeVolumeProfile',
  defaults: {
    chartConfig: {
      type: 'candle',
      boxUnitSize: 0,
      boxPercentage: 0,
      volumeInterval: '1 minutes',
    },
    type: 'fixedRangeVolumeProfile',
    name: 'frvp',
    config: {
      candleInterval: '1 minutes',
      volumeAreaPerc: 70,
      rowSize: 30,
      startTime: '09:30',
      endTime: '10:30',
      valuePaths: [
        'item0.month1Price'
      ]
    }
  },
  searchTerms: [
    'FRVP (Fixed Range Volume Profile)',
  ],
  inputSchema: [
   {
      name: 'volumeAreaPerc',
      type: pipeInputSchemaTypes.number,
      label: 'VolumeArea Percentage',
    },
    {
      name: 'startTime',
      type: pipeInputSchemaTypes.timeOfDay,
      label: 'Start Time',
    },
    {
      name: 'endTime',
      type: pipeInputSchemaTypes.timeOfDay,
      label: 'End Time',
    },
    {
      name: 'noOfCandles',
      type: pipeInputSchemaTypes.number,
      label: 'Period',
    },
    {
      name: 'candleInterval',
      isDisplay: false
    }
  ],
  configFormOptions: {
    valuePathEditable: true,
    configFieldOptions: {},
    valuePathSupportedSegments: [SEGMENT_CONFIG.future],
  },
  buildOutputSchema: (pipe) => {
    const { name, type } = pipe;

    const properties = [
      { day: 'previousDay', property: 'upperBand' },
      { day: 'previousDay', property: 'poc' },
      { day: 'previousDay', property: 'lowerBand' },
      { day: 'currentDay', property: 'upperBand' },
      { day: 'currentDay', property: 'poc' },
      { day: 'currentDay', property: 'lowerBand' },
    ];

    return _.map(properties, ({ day, property }) => {
      return {
        name: `${name}.${day}.${property}`,
        type: schemaTypes.number,
        indicatorType: type,
        category: 'indicator',
        label: `${name} ${day} ${property}`,
        shouldShowConfigs: [
          schemaShouldShowConfigTypes.adjustmentLeftOperand,
          schemaShouldShowConfigTypes.adjustmentRightOperand,
          schemaShouldShowConfigTypes.entryLeftOperand,
          schemaShouldShowConfigTypes.entryRightOperand,
          schemaShouldShowConfigTypes.exitLeftOperand,
          schemaShouldShowConfigTypes.exitRightOperand,
          schemaShouldShowConfigTypes.intentValuePath,
        ],
        priority: 70,
        schemaName: name
      };
    });
  },
  isEnabled: ApplicationDomainUtility.isAdmin,
  priority: 5
};
export default configuration;
